var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yd-rank"},[_c('tp-header',{attrs:{"groups":_vm.groups},on:{"onGroup":_vm.onSelectGroup}}),_c('div',{staticClass:"list"},[_c('tp-rank',{attrs:{"load":_vm.playerLoading,"ranks":_vm.rankList,"finish":_vm.loadFinished},on:{"onLoad":_vm.loadNextPage,"onDetail":_vm.clickPlayer}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }